// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__NOSIQ","image":"Image_image__18wsN","preloader":"Image_preloader__1aeBW","image-preloader":"Image_image-preloader__7k6Vv"};